// removed by extract-text-webpack-plugin
module.exports = {"nf-input-field__header":"nf-input-field__header","nf-input-field__input":"nf-input-field__input"};


//////////////////
// WEBPACK FOOTER
// ./src/components/form/RFFCheckbox/RFFCheckbox.scss
// module id = 5358
// module chunks = 1